import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import IConfirmComponent from '@components/FormFlow/Interfaces/FormflowComponents/IConfirmComponent';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Button, Col, Input, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { InstructionTaskComponent } from '../TextInstructionComponent';

let isValidate: any = []

interface IConfirmTaskComponentStateType {
    instructionTitle: string;
    required: boolean;
    description?: string
    inputValueConfirmYes: string;
    inputValueConfirmNo: string;
};

export class ConfirmComponent implements IConfirmComponent {
    id: string;
    required: boolean;
    type: ComponentType;
    title: string;
    description?: string;
    yesLabel: string;
    noLabel: string;

    constructor(id: string = '') {
        this.id = id;
        this.required = false;
        this.type = ComponentType.CONFIRM;
        this.title = '';
        this.yesLabel = 'SIM';
        this.noLabel = 'NÃO';
        return this;
    }
}

export default class ConfirmTaskComponent extends React.Component<IConfirmComponent, IConfirmTaskComponentStateType> {

    constructor(props: IConfirmComponent) {
        super(props);
        this.state = {
            instructionTitle: this.props.title || '',
            description: this.props.description ,
            required: this.props.required || false,
            inputValueConfirmYes: this.props.yesLabel || 'SIM',
            inputValueConfirmNo: this.props.noLabel || 'NÃO',
        };
    }

    componentDidMount() {
        this.setState({ instructionTitle: this.props.title ? this.props.title : '' })
    }

    handleIntructionTitleChange = async (evt: any) => {
        this.setState({ instructionTitle: evt.target.value });
    }

    handleDescriptionChange = async (evt: any) => {
        this.setState({ description: evt.target.value });
    }

    handleRequiredChange = async (evt: any) => {
        this.setState({ required: evt.target.checked });
    }

    handleInputValueConfirmYesChange = async (evt: any) => {
        this.setState({ inputValueConfirmYes: evt.target.value });
    }

    handleInputValueConfirmNoChange = async (evt: any) => {
        this.setState({ inputValueConfirmNo: evt.target.value });
    }

    isDisabled = async () => {
        if (this.state.inputValueConfirmYes === '') {
            isValidate.push(false)
        }
        else if (this.state.inputValueConfirmNo === '') {
            isValidate.push(false)
        }
        else {
            isValidate = []
        }
    }

    validationYesLabel() {
        this.isDisabled()
        let fieldIsRequired: JSX.Element = <div />;
        if (this.state.inputValueConfirmYes === '') {
            fieldIsRequired = (<span style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold' }} >{I18n.l("form.validation.field.required")}</span>)
        }
        return fieldIsRequired;
    }
    validationNoLabel() {
        this.isDisabled()
        let fieldIsRequired: JSX.Element = <div />;
        if (this.state.inputValueConfirmNo === '') {
            fieldIsRequired = (<span style={{ color: `${Theme.secondary.red}`, fontWeight: 'bold' }} >{I18n.l("form.validation.field.required")}</span>)
        }
        return fieldIsRequired;
    }

    onSubmiTextComponent(updateFormflowWithComponent: (component: IBaseComponent) => void) {
        const newConfirmtDataComponent: IConfirmComponent = {
            id: this.props.id,
            type: ComponentType.CONFIRM,
            title: this.state.instructionTitle,
            description: this.state.description,
            required: this.state.required,
            yesLabel: this.state.inputValueConfirmYes,
            noLabel: this.state.inputValueConfirmNo

        }

        updateFormflowWithComponent(newConfirmtDataComponent);
    }

    render() {
        const {
            title,
            required,
        } = this.props;
        const {
            instructionTitle,
            inputValueConfirmYes,

        } = this.state
        return (
            <Wrapper>
                <InstructionTaskComponent
                    visibleDescription={true}
                    inputDescriptionValue={this.props.description != undefined ? this.props.description : ''}
                    inputTitleValue={instructionTitle}
                    requiredCheckedValue={required}
                    onInputInstructionChange={() => this.handleIntructionTitleChange}
                    onChangeDescription={() => this.handleDescriptionChange}
                    onChangeRequiredCheckbox={() => this.handleRequiredChange}
                    titleComponent={I18n.l("formflow.components.confirmComponent.titleConfirmComponent")}
                    descriptionComponent={I18n.l("formflow.components.confirmComponent.descriptionConfirmComponent")}
                    exampleDescriptionComponent={I18n.l("formflow.components.confirmComponent.exampleDescriptionConfirmComponent")}
                    checkboxtTaskPerform={false}
                    conditionsTaskComponents={true}
                />
                <DividerBorder className="divider" />
                <p className="optional-confirm-condition-text" >{I18n.l("formflow.components.confirmComponent.optionalConfirmComponentConditions")}</p>
                <Row>
                    <Col sm={12} md={12} xl={12}>
                        <div className="input-confirm-yes">
                            <p>{I18n.l("formflow.components.confirmComponent.inputLabelConfirmYes")}</p>
                            <Input
                                defaultValue={this.state.inputValueConfirmYes}
                                style={this.state.inputValueConfirmYes=== '' ? { borderColor: `${Theme.secondary.red}` } : {}}
                                className={this.state.inputValueConfirmYes.length === 30 ? "apply-shake" : ''}
                                maxLength={30}
                                onChange={this.handleInputValueConfirmYesChange}
                            />
                            {this.validationYesLabel()}
                            <p style={{ float: 'right' }} className={this.state.inputValueConfirmYes.length < 30 ? "count-input" : "count-input-red"} >
                                {this.state.inputValueConfirmYes.length !== 0 ? this.state.inputValueConfirmYes.length + ' / 30' : '0 / 30'}
                            </p>
                        </div>
                    </Col>
                    <Col sm={12} md={12} xl={12}>
                        <div className="input-confirm-no">
                            <p>{I18n.l("formflow.components.confirmComponent.inputLabelConfirmNo")}</p>
                            <Input
                                defaultValue={this.state.inputValueConfirmNo}
                                style={this.state.inputValueConfirmNo=== '' ? { borderColor: `${Theme.secondary.red}` } : {}}
                                className={this.state.inputValueConfirmNo.length === 30 ? "apply-shake" : ''}
                                maxLength={30}
                                onChange={this.handleInputValueConfirmNoChange}
                            />
                            {this.validationNoLabel()}
                            <p style={{ float: 'right' }} className={this.state.inputValueConfirmNo.length < 30 ? "count-input" : "count-input-red"} >
                                {this.state.inputValueConfirmNo.length !== 0 ? this.state.inputValueConfirmNo.length + ' / 30' : '0 / 30'}
                            </p>
                        </div>
                    </Col>
                </Row>
                <FormflowContext.Consumer>
                    {({ destroyComponentModalWindow, updateFormflowWithComponent }) => (
                        <div>
                            <ButtonStyle>
                                <Row type="flex" justify="end">
                                    <Button className="button-cancel" type="primary" onClick={destroyComponentModalWindow} ghost>{I18n.l('common.cancel')}</Button>
                                    <Button className="button-save" type="primary" disabled={instructionTitle.length === 0 || instructionTitle.length < 3 || isValidate.length !== 0 ? true : false} onClick={() => { this.onSubmiTextComponent(updateFormflowWithComponent) }} >{I18n.l('common.save')}</Button>
                                </Row>
                            </ButtonStyle>
                        </div>
                    )}
                </FormflowContext.Consumer>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
    width:100%;
    .optional-confirm-condition-text{
        margin-top: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .input-confirm-yes{
        width:50%;
        margin-top: 1rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .input-confirm-no{
        width:50%;
        margin-top: 1rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .count-input{
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .count-input-red{
        color: ${Theme.secondary.red};
        font-weight: bold;
    }
    @keyframes shake {
        10%, 90% {
          transform: translate3d(-1px, 0, 0);
        }
      
        20%, 80% {
          transform: translate3d(2px, 0, 0);
        }
      
        30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
        }
      
        40%, 60% {
          transform: translate3d(4px, 0, 0);
        }
      }
      .apply-shake {
          animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      }
`

const DividerBorder = styled.div`
    margin-top: 2rem;
    margin-left: 3rem;
    margin-right: 3rem;   
    border-bottom: 1px solid ${Theme.secondary.midGrey};
`

const ButtonStyle = styled.div`
    float:right;
    margin-top: 5vh;
    margin-bottom: 5vh;
    margin-right: 50px;
    
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`;
